import { WidgetSettings } from '@gsc/types'
import { Event } from './event'
import { ConfigBase } from './config'

export class GTMConfig extends ConfigBase {
  public dataLayerName = 'dataLayer'

  constructor(config?: any) {
    super(config)
  }

  public isWidgetEnabled(widget: Partial<WidgetSettings>): boolean {
    const widgetEnabled = (widget.settings || {}).trackGTM
    return widgetEnabled !== false && this.isEnabled() && (this.isEnabledDefault() || !!widgetEnabled)
  }

  protected getQueue(): (e: Event) => void {
    const dl = (window as any)[this.dataLayerName]
    if (dl && typeof dl.push === 'function') {
      return (e: Event) => dl.push(this.transform(e))
    }
  }

  private transform(e: Event): any {
    const eventName = `gsc.${e.type}`
    const data: any = {
      event: eventName,
      'gsc.eventData': e.prettyData(),
    }
    if (e.widget) {
      data['gsc.widgetId'] = e.widget.id
      data['gsc.widgetName'] = e.widget.name
    }
    return data
  }
}
